import { render, staticRenderFns } from "./JsonCustomViewer.vue?vue&type=template&id=5c31a19c"
import script from "./JsonCustomViewer.vue?vue&type=script&lang=js"
export * from "./JsonCustomViewer.vue?vue&type=script&lang=js"
import style0 from "./JsonCustomViewer.vue?vue&type=style&index=0&id=5c31a19c&prod&lang=scss"


/* normalize component */
import normalizer from "!../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  null,
  null
  
)

export default component.exports